import { useState, } from 'react';
import { getAssetTypeOptions } from '../../../model/get-asset-type-options';
import { FolderAssetType } from '../../../model/constants';

export const useAssetTypeState = ({ i18n, logger, handleUsage }) => {
  const assetTypes = getAssetTypeOptions(i18n);

  const [assetTypesState, setAssetTypesState] = useState(() => {
    const initialState = {};
    assetTypes.forEach((option) => {
      initialState[option.key] = false;
    });
    initialState[FolderAssetType.All] = true;
    return initialState;
  });

  const toggleAssetType = (key) => {
    const newAssetTypesState = {};
    assetTypes.forEach((option) => {
      const { key: optionKey } = option;
      if (optionKey === key) {
        newAssetTypesState[optionKey] = !assetTypesState[optionKey];
      } else {
        newAssetTypesState[optionKey] = false;
      }
    });
    if (newAssetTypesState[key] === false) {
      newAssetTypesState[FolderAssetType.All] = true;
    }
    logger.logTrace('toggle the media type assetTypes', { assetTypesState: newAssetTypesState });
    if (handleUsage) {
      handleUsage();
    }
    setAssetTypesState(newAssetTypesState);
  };

  const isImageSelected = assetTypesState[FolderAssetType.Image];
  const isVideoSelected = assetTypesState[FolderAssetType.Video];

  return {
    toggleAssetType,
    assetTypesState,
    assetTypes,
    isImageSelected,
    isVideoSelected,
  };
};
